define.alias("shared/components/shared/ui/banner", "media/components/shared/ui/banner");